import {observer} from "mobx-react";
import * as React from "react";
import {useLocation, useNavigate, useParams} from "react-router-dom";
import {useApplication} from "../../ApplicationProvider";
import {useNavigatorFeature} from "../../useFeature";
import LayoutContentWrapper from "../../components/layout/LayoutContentWrapper";
import DeliverySiteFormScreen from "../../components/forms/DeliverySiteFormScreen";
import DeliverySiteFeature from "./DeliverySiteFeature";

function DeliverySiteScreen() {
    const application = useApplication();
    const navigator = useNavigate();
    const location = useLocation();
    const {customerId, deliverySiteCode} = useParams();
    const deliverySite = location.state?.deliverySite;

    const feature = useNavigatorFeature(
        () => new DeliverySiteFeature(application, navigator, deliverySite),
        navigator,
        [customerId, deliverySiteCode]
    );

    const isFeatureReady = () => feature && feature.loaded;

    return (
        <LayoutContentWrapper
            isLoading={!isFeatureReady()}
            renderContent={() => isFeatureReady() && <DeliverySiteFormScreen deliverySite={feature.form}/>}
        />
    );
}

export default observer(DeliverySiteScreen);
